import React from 'react';
import type { Client } from '@hero/schema';
import { useClientDrawerStore } from '@hero/hooks-shared';
import { TableCell } from '../../../ui/Table/Table';
import { MianAvatar } from '../../../app/MianAvatar';
import { ClientRolesBadge } from '../Status/ClientRolesBadge';
import { formatDateMain } from '@hero/core';
import { CellAction } from '../../../app/Table/CellAction';

export interface ClientRowProps {
  client: Client;
}

export const ClientRow: React.FC<ClientRowProps> = ({ client }) => {
  const openDrawer = useClientDrawerStore(s => s.open);
  const handleClick = () => openDrawer(String(client._id));

  return (
    <>
      <TableCell className="cursor-pointer text-gray-600 body2" onClick={handleClick}>
        <div className="flex items-center gap-3">
          <MianAvatar src="/images/avatar.png" className="size-[44px]" />
          {client.name}
        </div>
      </TableCell>
      <TableCell className="cursor-pointer" onClick={handleClick}>
        <ClientRolesBadge roles={client.roles} className="px-1 py-0.5" />
      </TableCell>
      <TableCell className="cursor-pointer" onClick={handleClick}>
        {formatDateMain({ date: client.doc.createdAt, format: 'date_time' })}
      </TableCell>
      <TableCell>
        <CellAction type="view" onClick={handleClick} />
      </TableCell>
    </>
  );
};
